import { render, staticRenderFns } from "./AddCoupon.vue?vue&type=template&id=2dc0004e"
import script from "./AddCoupon.vue?vue&type=script&lang=js"
export * from "./AddCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports